import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface InspectionLayerState {
  active: boolean;
  xray: boolean;
  anomalyLabelsHiddenByUser: boolean;
  selectedElementTypeIds: string[];
}

export interface ElementsLayerState {
  active: boolean;
  selectedElementTypeIds: string[];
}

export interface StructuralLabelsLayerState {
  active: boolean;
  selectedElementType: string;
}

export interface ViewModeLayersState {
  inspection: InspectionLayerState;
  elements: ElementsLayerState;
  structuralLabels: StructuralLabelsLayerState;
}

@Injectable({
  providedIn: 'root'
})
export class ViewModeLayersStateService {
  private readonly stateSubject = new BehaviorSubject<ViewModeLayersState>({
    inspection: {
      active: false,
      xray: false,
      anomalyLabelsHiddenByUser: false,
      selectedElementTypeIds: [],
    },
    elements: {
      active: false,
      selectedElementTypeIds: [],
    },
    structuralLabels: {
      active: false,
      selectedElementType: '',
    },
  });

  public readonly state$: Observable<ViewModeLayersState> = this.stateSubject.asObservable();

  public get snapshot(): ViewModeLayersState {
    return this.stateSubject.value;
  }

  public updateInspection(partial: Partial<InspectionLayerState>): void {
    const current = this.snapshot;
    this.stateSubject.next({
      ...current,
      inspection: {
        ...current.inspection,
        ...partial,
        selectedElementTypeIds: partial.selectedElementTypeIds
          ? [...partial.selectedElementTypeIds]
          : current.inspection.selectedElementTypeIds,
      },
    });
  }

  public updateElements(partial: Partial<ElementsLayerState>): void {
    const current = this.snapshot;
    this.stateSubject.next({
      ...current,
      elements: {
        ...current.elements,
        ...partial,
        selectedElementTypeIds: partial.selectedElementTypeIds
          ? [...partial.selectedElementTypeIds]
          : current.elements.selectedElementTypeIds,
      },
    });
  }

  public updateStructuralLabels(partial: Partial<StructuralLabelsLayerState>): void {
    const current = this.snapshot;
    this.stateSubject.next({
      ...current,
      structuralLabels: {
        ...current.structuralLabels,
        ...partial,
      },
    });
  }
}
